/**
 * The Beauty Awards - Custom JavaScript
 */
(function() {
    'use strict';

    // ── Hero video: iOS autoplay fallback ────────────────────────────────────
    // iOS Safari (especially with Low Power Mode) can silently block the HTML
    // `autoplay` attribute. We call .play() explicitly and catch the rejection
    // so video plays whenever the browser permits it.
    document.addEventListener('DOMContentLoaded', function () {
        var heroVideos = document.querySelectorAll('.hero-video, .h2b-bg-video, .nlb-bg-video');
        if (!heroVideos.length) return;

        function attemptPlay(video) {
            var playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(function () {
                    // Autoplay blocked (e.g. Low Power Mode). Nothing to do —
                    // the poster or static background will remain visible.
                });
            }
        }

        // Use IntersectionObserver to trigger play when video enters viewport
        // (handles cases where the video is not in view on initial load).
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        attemptPlay(entry.target);
                    }
                });
            }, { threshold: 0 });

            heroVideos.forEach(function (video) {
                observer.observe(video);
            });
        } else {
            // Fallback for browsers without IntersectionObserver.
            heroVideos.forEach(attemptPlay);
        }
    });

    // ── AOS (Animate On Scroll) ──────────────────────────────────────────────
    // Initialise AOS once the DOM is ready. Global defaults can be overridden
    // per-element with data-aos-* attributes set in each block template.
    document.addEventListener('DOMContentLoaded', function () {
        if (typeof AOS !== 'undefined') {
            AOS.init({
                duration: 800,
                easing: 'ease',
                once: true,
                offset: 120
            });
        }
    });

    // ── Hero Badge: fade out on scroll, fade in on return to top ──────────────
    document.addEventListener('DOMContentLoaded', function () {
        var badge = document.querySelector('.hero-badge');
        if (!badge) return;

        // Respect user motion preference — leave badge opacity untouched.
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (prefersReducedMotion.matches) return;

        var FADE_OUT_BY = 200; // px of scroll before badge is fully hidden

        function updateBadgeOpacity() {
            var scrollY  = window.scrollY || window.pageYOffset;
            var opacity  = Math.max(0, 1 - scrollY / FADE_OUT_BY);
            badge.style.opacity       = opacity;
            badge.style.pointerEvents = opacity <= 0 ? 'none' : '';
        }

        window.addEventListener('scroll', updateBadgeOpacity, { passive: true });

        // Handle page reload while already scrolled
        updateBadgeOpacity();
    });

    // Mobile nav toggle
    var toggle = document.getElementById('mobile-nav-toggle');
    var header = document.getElementById('site-header');

    if (toggle && header) {
        toggle.addEventListener('click', function() {
            header.classList.toggle('nav-open');
        });
    }

    // ── Header nav: mobile submenu tap toggle ─────────────────────────
    // Desktop hover is pure CSS. Mobile tap toggles .sub-open on the parent li.
    (function() {
        var nav = document.getElementById('header-navigation');
        if (!nav) return;

        nav.addEventListener('click', function(e) {
            var link = e.target.closest('li.menu-item-has-children > a');
            if (!link) return;
            if (window.innerWidth >= 768) return; // desktop handled by CSS :hover

            e.preventDefault();
            var parentLi = link.parentElement;
            var isOpen = parentLi.classList.contains('sub-open');

            nav.querySelectorAll('li.menu-item-has-children.sub-open').forEach(function(li) {
                li.classList.remove('sub-open');
            });

            if (!isOpen) { parentLi.classList.add('sub-open'); }
        });

        // Close open submenus when clicking outside the nav
        document.addEventListener('click', function(e) {
            if (!nav.contains(e.target)) {
                nav.querySelectorAll('li.menu-item-has-children.sub-open').forEach(function(li) {
                    li.classList.remove('sub-open');
                });
            }
        });
    })();

    // ── Carousel Block: respect prefers-reduced-motion ───────────────────────
    // The marquee animation is CSS-driven; we only pause it for users who
    // prefer reduced motion (CSS alone doesn't handle all UA variations).
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function updateCarouselMotion() {
        var tracks = document.querySelectorAll('.carousel_block .carousel-track');
        tracks.forEach(function(track) {
            track.style.animationPlayState = prefersReduced.matches ? 'paused' : 'running';
        });
    }

    // Apply on load and whenever the preference changes
    document.addEventListener('DOMContentLoaded', updateCarouselMotion);
    if (typeof prefersReduced.addEventListener === 'function') {
        prefersReduced.addEventListener('change', updateCarouselMotion);
    }
    // ── Vote for Favourites Block: tab switching + mobile dropdown ───────────
    document.addEventListener('DOMContentLoaded', function () {
        var sections = document.querySelectorAll('.vote_for_favourites');

        sections.forEach(function (section) {
            var buttons        = section.querySelectorAll('.vff-tab-btn');
            var panels         = section.querySelectorAll('.vff-tab-panel');
            var dropdownWrap   = section.querySelector('.vff-filter-dropdown');
            var dropdownTrig   = section.querySelector('.vff-dropdown-trigger');
            var dropdownMenu   = section.querySelector('.vff-dropdown-menu');
            var dropdownLabel  = section.querySelector('.vff-dropdown-label');
            var dropdownOpts   = section.querySelectorAll('.vff-dropdown-opt');

            if (!buttons.length || !panels.length) {
                return;
            }

            function syncTabs(targetTab) {
                buttons.forEach(function (b) {
                    var on = b.getAttribute('data-vff-tab') === targetTab;
                    b.classList.toggle('is-active', on);
                    b.setAttribute('aria-selected', on ? 'true' : 'false');
                });
            }

            function syncDropdown(targetTab, labelText) {
                if (dropdownLabel && labelText) dropdownLabel.textContent = labelText;
                dropdownOpts.forEach(function (opt) {
                    var on = opt.getAttribute('data-vff-tab') === targetTab;
                    opt.classList.toggle('is-selected', on);
                    opt.setAttribute('aria-selected', on ? 'true' : 'false');
                });
            }

            function syncPanels(targetTab) {
                panels.forEach(function (panel) {
                    if (panel.getAttribute('data-vff-panel') === targetTab) {
                        panel.classList.add('is-active');
                        panel.removeAttribute('hidden');
                    } else {
                        panel.classList.remove('is-active');
                        panel.setAttribute('hidden', '');
                    }
                });
            }

            function closeDropdown() {
                if (!dropdownWrap) return;
                dropdownWrap.classList.remove('is-open');
                if (dropdownTrig) dropdownTrig.setAttribute('aria-expanded', 'false');
                if (dropdownMenu) dropdownMenu.setAttribute('aria-hidden', 'true');
            }

            function activate(targetTab, labelText) {
                syncTabs(targetTab);
                syncDropdown(targetTab, labelText);
                syncPanels(targetTab);
            }

            buttons.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var targetTab = btn.getAttribute('data-vff-tab');
                    var labelText = (btn.textContent || '').trim();
                    activate(targetTab, labelText);
                });
            });

            if (dropdownTrig && dropdownWrap) {
                dropdownTrig.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var isOpen = dropdownWrap.classList.toggle('is-open');
                    dropdownTrig.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    if (dropdownMenu) dropdownMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                });
            }

            dropdownOpts.forEach(function (opt) {
                opt.addEventListener('click', function () {
                    var targetTab = opt.getAttribute('data-vff-tab');
                    var labelText = (opt.textContent || '').trim();
                    activate(targetTab, labelText);
                    closeDropdown();
                });
            });

            document.addEventListener('click', function (e) {
                if (dropdownWrap && !dropdownWrap.contains(e.target)) closeDropdown();
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') closeDropdown();
            });
        });
    });
    // ── Shortlist Block: tab switching + mobile dropdown ─────────────────────
    document.addEventListener('DOMContentLoaded', function () {
        var slSections = document.querySelectorAll('.shortlist');

        slSections.forEach(function (section) {
            var buttons        = section.querySelectorAll('.sl-tab-btn');
            var panels         = section.querySelectorAll('.sl-tab-panel');
            var dropdownWrap   = section.querySelector('.sl-filter-dropdown');
            var dropdownTrig   = section.querySelector('.sl-dropdown-trigger');
            var dropdownMenu   = section.querySelector('.sl-dropdown-menu');
            var dropdownLabel  = section.querySelector('.sl-dropdown-label');
            var dropdownOpts   = section.querySelectorAll('.sl-dropdown-opt');

            if (!buttons.length || !panels.length) {
                return;
            }

            function syncTabs(targetTab) {
                buttons.forEach(function (b) {
                    var on = b.getAttribute('data-sl-tab') === targetTab;
                    b.classList.toggle('is-active', on);
                    b.setAttribute('aria-selected', on ? 'true' : 'false');
                });
            }

            function syncDropdown(targetTab, labelText) {
                if (dropdownLabel && labelText) dropdownLabel.textContent = labelText;
                dropdownOpts.forEach(function (opt) {
                    var on = opt.getAttribute('data-sl-tab') === targetTab;
                    opt.classList.toggle('is-selected', on);
                    opt.setAttribute('aria-selected', on ? 'true' : 'false');
                });
            }

            function syncPanels(targetTab) {
                panels.forEach(function (panel) {
                    if (panel.getAttribute('data-sl-panel') === targetTab) {
                        panel.classList.add('is-active');
                        panel.removeAttribute('hidden');
                    } else {
                        panel.classList.remove('is-active');
                        panel.setAttribute('hidden', '');
                    }
                });
            }

            function closeDropdown() {
                if (!dropdownWrap) return;
                dropdownWrap.classList.remove('is-open');
                if (dropdownTrig) dropdownTrig.setAttribute('aria-expanded', 'false');
                if (dropdownMenu) dropdownMenu.setAttribute('aria-hidden', 'true');
            }

            function activate(targetTab, labelText) {
                section.dispatchEvent(new CustomEvent('shortlist:before-tab-change'));
                syncTabs(targetTab);
                syncDropdown(targetTab, labelText);
                syncPanels(targetTab);
            }

            buttons.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var targetTab = btn.getAttribute('data-sl-tab');
                    var labelText = (btn.textContent || '').trim();
                    activate(targetTab, labelText);
                });
            });

            if (dropdownTrig && dropdownWrap) {
                dropdownTrig.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var isOpen = dropdownWrap.classList.toggle('is-open');
                    dropdownTrig.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    if (dropdownMenu) dropdownMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                });
            }

            dropdownOpts.forEach(function (opt) {
                opt.addEventListener('click', function () {
                    var targetTab = opt.getAttribute('data-sl-tab');
                    var labelText = (opt.textContent || '').trim();
                    activate(targetTab, labelText);
                    closeDropdown();
                });
            });

            document.addEventListener('click', function (e) {
                if (dropdownWrap && !dropdownWrap.contains(e.target)) closeDropdown();
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') closeDropdown();
            });
        });
    });

    // ── Shortlist Block: expand / collapse described products ────────────────
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.page-block.shortlist').forEach(function (section) {
            if (section.dataset.clickEnabled === '0') return;

            var cards = section.querySelectorAll('.sl-product-card.is-clickable');
            if (!cards.length) return;

            function prefersReducedMotion() {
                return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            }

            function getSafeViewportTop() {
                var isMobile = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
                var headerOffset = isMobile ? 68 : 168;
                var tabBar = section.querySelector('.sl-tabs-sticky');
                var tabBarHeight = tabBar ? tabBar.offsetHeight : 0;

                if (tabBar) {
                    var configuredTop = parseFloat(window.getComputedStyle(tabBar).top);
                    if (!isNaN(configuredTop)) headerOffset = configuredTop;
                }

                return headerOffset + tabBarHeight + 16;
            }

            function scrollCloseButtonIntoView(full) {
                var closeButton = full.querySelector('.close-button');
                if (!closeButton) return;

                var buttonRect = closeButton.getBoundingClientRect();
                var safeTop = Math.min(
                    getSafeViewportTop(),
                    Math.max(16, window.innerHeight - buttonRect.height - 16)
                );
                var targetTop = Math.max(0, window.pageYOffset + buttonRect.top - safeTop);

                window.scrollTo({
                    top: targetTop,
                    behavior: prefersReducedMotion() ? 'auto' : 'smooth'
                });
            }

            function rememberCardPosition(card) {
                card._shortlistReturnTop = card.getBoundingClientRect().top;
            }

            function restoreCardPosition(card) {
                if (typeof card._shortlistReturnTop !== 'number') return;

                var currentTop = card.getBoundingClientRect().top;
                var scrollDelta = currentTop - card._shortlistReturnTop;

                if (Math.abs(scrollDelta) > 1) {
                    window.scrollBy({ top: scrollDelta, behavior: 'auto' });
                }

                card._shortlistReturnTop = null;
            }

            function getPanel(card) {
                var target = card.getAttribute('data-sl-product-value');
                return target ? section.querySelector('.sl-product-full[data-sl-product-target="' + target + '"]') : null;
            }

            function getListings(card) {
                var tabPanel = card.closest('.sl-tab-panel');
                return tabPanel ? tabPanel.querySelector('.sl-panel-listings') : null;
            }

            function setPanelAccessibility(full, isOpen) {
                var closeButton = full.querySelector('.close-button');
                full.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                if (closeButton) closeButton.setAttribute('tabindex', isOpen ? '0' : '-1');
            }

            function focusWithoutScroll(element) {
                if (!element || !element.focus) return;

                try {
                    element.focus({ preventScroll: true });
                } catch (e) {
                    element.focus();
                }
            }

            function clearPanelTimer(full) {
                if (!full._shortlistTimer) return;
                window.clearTimeout(full._shortlistTimer);
                full._shortlistTimer = null;
            }

            function closeCard(card, restoreFocus, immediate) {
                var full = getPanel(card);
                var listings = getListings(card);
                if (!full) return;

                clearPanelTimer(full);
                card.classList.remove('is-active');
                card.setAttribute('aria-expanded', 'false');

                if (immediate || prefersReducedMotion()) {
                    full.style.height = '0';
                    if (listings) listings.style.height = '';
                    setPanelAccessibility(full, false);
                    if (restoreFocus) {
                        restoreCardPosition(card);
                        focusWithoutScroll(card);
                    } else {
                        card._shortlistReturnTop = null;
                    }
                    return;
                }

                // Give the auto-height panel a measured starting point before
                // animating it closed and restoring the product listings.
                full.style.height = full.scrollHeight + 'px';
                full.getBoundingClientRect();
                full.style.height = '0';
                if (listings) listings.style.height = listings.scrollHeight + 'px';

                setPanelAccessibility(full, false);
                if (restoreFocus) focusWithoutScroll(card);

                full._shortlistTimer = window.setTimeout(function () {
                    if (listings) listings.style.height = '';
                    if (restoreFocus) {
                        restoreCardPosition(card);
                        focusWithoutScroll(card);
                    }
                    full._shortlistTimer = null;
                }, 350);
            }

            function closeOpenCard(restoreFocus, immediate) {
                var openCard = section.querySelector('.sl-product-card.is-clickable.is-active');
                if (openCard) closeCard(openCard, restoreFocus, immediate);
            }

            function openCard(card) {
                var full = getPanel(card);
                var listings = getListings(card);
                var closeButton;

                if (!full || !listings) return;

                closeOpenCard(false, true);
                clearPanelTimer(full);
                rememberCardPosition(card);

                listings.style.height = listings.scrollHeight + 'px';
                listings.getBoundingClientRect();

                card.classList.add('is-active');
                card.setAttribute('aria-expanded', 'true');
                setPanelAccessibility(full, true);

                full.style.height = '0';
                full.getBoundingClientRect();
                full.style.height = full.scrollHeight + 'px';
                listings.style.height = '0';

                closeButton = full.querySelector('.close-button');
                focusWithoutScroll(closeButton);

                full._shortlistTimer = window.setTimeout(function () {
                    if (!card.classList.contains('is-active')) return;

                    full.style.height = 'auto';
                    full._shortlistTimer = null;
                    scrollCloseButtonIntoView(full);
                }, prefersReducedMotion() ? 0 : 350);
            }

            cards.forEach(function (card) {
                card.addEventListener('click', function () {
                    openCard(card);
                });
            });

            section.querySelectorAll('.sl-product-full .close-button').forEach(function (button) {
                button.addEventListener('click', function () {
                    var full = button.closest('.sl-product-full');
                    var target = full ? full.getAttribute('data-sl-product-target') : '';
                    var card = target ? section.querySelector('.sl-product-card[data-sl-product-value="' + target + '"]') : null;

                    if (card) closeCard(card, true, false);
                });
            });

            section.addEventListener('shortlist:before-tab-change', function () {
                closeOpenCard(false, true);
            });

            section.addEventListener('keydown', function (event) {
                if (event.key !== 'Escape') return;

                var openCard = section.querySelector('.sl-product-card.is-clickable.is-active');
                if (!openCard) return;

                event.preventDefault();
                closeCard(openCard, true, false);
            });
        });
    });

    // ── Testimonials Grid Block: Show More / Show Less toggle ────────────────
    document.addEventListener('DOMContentLoaded', function () {
        var tgSections = document.querySelectorAll('.testimonials_grid');

        tgSections.forEach(function (section) {
            var gridWrap = section.querySelector('.tg-grid-wrap');
            var btn      = section.querySelector('.tg-show-more-btn');
            var label    = btn ? btn.querySelector('.tg-btn-label') : null;

            if (!gridWrap || !btn || !label) {
                return;
            }

            var labelMore = btn.getAttribute('data-label-more') || 'Show More';
            var labelLess = btn.getAttribute('data-label-less') || 'Show Less';

            btn.addEventListener('click', function () {
                var isExpanded = btn.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    // Collapse
                    gridWrap.classList.add('is-collapsed');
                    btn.setAttribute('aria-expanded', 'false');
                    label.textContent = labelMore;

                    // Scroll back to the top of the section so collapsed state is visible
                    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    // Expand
                    gridWrap.classList.remove('is-collapsed');
                    btn.setAttribute('aria-expanded', 'true');
                    label.textContent = labelLess;
                }
            });
        });
    });

    // ── People Block: expand / collapse person panels ────────────────────────
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.page-block.people').forEach(function (section) {
            var clickEnabled = section.dataset.clickEnabled !== '0';
            var previews = section.querySelectorAll('.person-preview');

            function getScrollBehavior() {
                return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            }

            function focusOpenedPanel(full) {
                var closeButton = full.querySelector('.close-button');

                if (!closeButton || !closeButton.focus) return;

                try {
                    closeButton.focus({ preventScroll: true });
                } catch (e) {
                    closeButton.focus();
                }
            }

            function scrollToOpenedPanel(full) {
                full.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
            }

            function scheduleOpenedPanelScroll(full) {
                var didScroll = false;
                var timeout;

                function runScroll() {
                    if (didScroll) return;

                    didScroll = true;
                    full.removeEventListener('transitionend', handleTransitionEnd);
                    window.clearTimeout(timeout);

                    if (full.style.height === '0px' || full.style.height === '0') return;

                    scrollToOpenedPanel(full);
                }

                function handleTransitionEnd(e) {
                    if (e.target === full && e.propertyName === 'height') {
                        runScroll();
                    }
                }

                full.addEventListener('transitionend', handleTransitionEnd);
                timeout = window.setTimeout(runScroll, 350);
            }

            function closePanel(preview, full) {
                var grid = section.querySelector('.people-grid');
                var text = section.querySelector('.text-container');

                preview.classList.remove('is-active');
                preview.setAttribute('aria-expanded', 'false');
                full.style.height = '0';

                if (grid) grid.style.height = grid.scrollHeight + 'px';
                if (text) text.style.height = text.scrollHeight + 'px';
            }

            previews.forEach(function (preview) {
                if (!clickEnabled) return;

                preview.setAttribute('role', 'button');
                preview.setAttribute('tabindex', '0');
                preview.setAttribute('aria-expanded', 'false');

                function openPreview() {
                    var value = preview.getAttribute('data-person-value');
                    var full  = section.querySelector('.person-full[data-person-target="' + value + '"]');
                    var grid  = section.querySelector('.people-grid');
                    var text  = section.querySelector('.text-container');

                    if (!full) return;

                    // Close any other open panel
                    previews.forEach(function (p) {
                        if (p.classList.contains('is-active') && p !== preview) {
                            var otherFull = section.querySelector(
                                '.person-full[data-person-target="' + p.getAttribute('data-person-value') + '"]'
                            );
                            p.classList.remove('is-active');
                            p.setAttribute('aria-expanded', 'false');
                            if (otherFull) otherFull.style.height = '0';
                        }
                    });

                    // Collapse grid and text container
                    if (grid) grid.style.height = grid.scrollHeight + 'px';
                    if (text) text.style.height = text.scrollHeight + 'px';

                    // Force reflow so the transition fires from the measured height
                    if (grid) grid.getBoundingClientRect();
                    if (text) text.getBoundingClientRect();

                    preview.classList.add('is-active');
                    preview.setAttribute('aria-expanded', 'true');
                    full.style.height = full.scrollHeight + 'px';

                    if (grid) grid.style.height = '0';
                    if (text) text.style.height = '0';

                    focusOpenedPanel(full);
                    scheduleOpenedPanelScroll(full);

                }

                preview.addEventListener('click', openPreview);
                preview.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openPreview();
                    }
                });
            });

            // Close buttons
            section.querySelectorAll('.person-full .close-button').forEach(function (btn) {
                if (!clickEnabled) return;
                btn.addEventListener('click', function () {
                    var full    = btn.closest('.person-full');
                    var target  = full.getAttribute('data-person-target');
                    var preview = section.querySelector('.person-preview[data-person-value="' + target + '"]');
                    if (preview) closePanel(preview, full);
                });
            });
        });
    });

    // ── Products Block: expand / collapse product panels ─────────────────
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.page-block.products').forEach(function (section) {
            var clickEnabled = section.dataset.clickEnabled !== '0';
            var previews = section.querySelectorAll('.product-preview');

            function closePanel(preview, full) {
                var grid = section.querySelector('.products-grid');
                var text = section.querySelector('.text-container');

                preview.classList.remove('is-active');
                preview.setAttribute('aria-expanded', 'false');
                full.style.height = '0';

                if (grid) grid.style.height = grid.scrollHeight + 'px';
                if (text) text.style.height = text.scrollHeight + 'px';
            }

            previews.forEach(function (preview) {
                if (!clickEnabled) return;

                preview.setAttribute('role', 'button');
                preview.setAttribute('tabindex', '0');
                preview.setAttribute('aria-expanded', 'false');

                function openPreview() {
                    var value = preview.getAttribute('data-product-value');
                    var full  = section.querySelector('.product-full[data-product-target="' + value + '"]');
                    var grid  = section.querySelector('.products-grid');
                    var text  = section.querySelector('.text-container');

                    if (!full) return;

                    // Close any other open panel
                    previews.forEach(function (p) {
                        if (p.classList.contains('is-active') && p !== preview) {
                            var otherFull = section.querySelector(
                                '.product-full[data-product-target="' + p.getAttribute('data-product-value') + '"]'
                            );
                            p.classList.remove('is-active');
                            p.setAttribute('aria-expanded', 'false');
                            if (otherFull) otherFull.style.height = '0';
                        }
                    });

                    // Collapse grid and text container
                    if (grid) grid.style.height = grid.scrollHeight + 'px';
                    if (text) text.style.height = text.scrollHeight + 'px';

                    // Force reflow so the transition fires from the measured height
                    if (grid) grid.getBoundingClientRect();
                    if (text) text.getBoundingClientRect();

                    preview.classList.add('is-active');
                    preview.setAttribute('aria-expanded', 'true');
                    full.style.height = full.scrollHeight + 'px';

                    if (grid) grid.style.height = '0';
                    if (text) text.style.height = '0';
                }

                preview.addEventListener('click', openPreview);
                preview.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openPreview();
                    }
                });
            });

            // Close buttons
            section.querySelectorAll('.product-full .close-button').forEach(function (btn) {
                if (!clickEnabled) return;
                btn.addEventListener('click', function () {
                    var full    = btn.closest('.product-full');
                    var target  = full.getAttribute('data-product-target');
                    var preview = section.querySelector('.product-preview[data-product-value="' + target + '"]');
                    if (preview) closePanel(preview, full);
                });
            });
        });
    });

    // ── Products Block: category filter ──────────────────────────────────
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.page-block.products').forEach(function (section) {
            var filter = section.querySelector('.prod-filter');
            if (!filter) return;

            var tabBtns         = filter.querySelectorAll('.prod-tab-btn');
            var dropdownWrapper = filter.querySelector('.prod-filter-dropdown');
            var dropdownTrigger = filter.querySelector('.prod-dropdown-trigger');
            var dropdownMenu    = filter.querySelector('.prod-dropdown-menu');
            var dropdownLabel   = filter.querySelector('.prod-dropdown-label');
            var dropdownOpts    = filter.querySelectorAll('.prod-dropdown-opt');
            var previews        = section.querySelectorAll('.product-preview');
            var fullPanels      = section.querySelectorAll('.product-full');
            var grid            = section.querySelector('.products-grid');
            // Shortlisted-only render path uses .shortlist-group as the filterable unit.
            var shortlistGroups = section.querySelectorAll('.shortlist-group');

            // ── Collapse any open expanded panel before re-filtering ──────
            function collapseOpenPanel() {
                fullPanels.forEach(function (fp) {
                    if (fp.style.height && fp.style.height !== '0px' && fp.style.height !== '0') {
                        fp.style.height = '0';
                    }
                });
                previews.forEach(function (p) {
                    p.classList.remove('is-active');
                    if (p.getAttribute('aria-expanded') !== null) {
                        p.setAttribute('aria-expanded', 'false');
                    }
                });
                // Release grid height-lock so filtering shows/hides correctly
                if (grid) grid.style.height = '';
            }

            // ── Show / hide product cards based on filter value ───────────
            function filterProducts(filterValue) {
                collapseOpenPanel();
                previews.forEach(function (preview) {
                    var cat = (preview.getAttribute('data-category') || '').trim();
                    if (filterValue === 'all' || cat === filterValue) {
                        preview.style.display = '';
                        // AOS uses once:true — elements below the fold that were never
                        // scrolled into view remain opacity:0 in the initial AOS state.
                        // Force them visible so the filtered result is never blank.
                        if (preview.hasAttribute('data-aos') && !preview.classList.contains('aos-animate')) {
                            preview.classList.add('aos-animate');
                        }
                    } else {
                        preview.style.display = 'none';
                    }
                });
                shortlistGroups.forEach(function (group) {
                    var cat = (group.getAttribute('data-category') || '').trim();
                    if (filterValue === 'all' || cat === filterValue) {
                        group.style.display = '';
                        if (group.hasAttribute('data-aos') && !group.classList.contains('aos-animate')) {
                            group.classList.add('aos-animate');
                        }
                    } else {
                        group.style.display = 'none';
                    }
                });
                // Refresh AOS so any newly-visible items in the viewport also get
                // their transition triggered via the normal IntersectionObserver path.
                if (typeof AOS !== 'undefined') {
                    AOS.refresh();
                }
            }

            // ── Sync dropdown label + selected state ──────────────────────
            function syncDropdown(filterValue, labelText) {
                if (dropdownLabel) dropdownLabel.textContent = labelText;
                dropdownOpts.forEach(function (opt) {
                    var isSelected = opt.getAttribute('data-filter') === filterValue;
                    opt.classList.toggle('is-selected', isSelected);
                    opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                });
            }

            // ── Sync tab pills active state ───────────────────────────────
            function syncTabs(filterValue) {
                tabBtns.forEach(function (btn) {
                    var isActive = btn.getAttribute('data-filter') === filterValue;
                    btn.classList.toggle('is-active', isActive);
                    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });
            }

            // ── Close dropdown ────────────────────────────────────────────
            function closeDropdown() {
                if (!dropdownWrapper) return;
                dropdownWrapper.classList.remove('is-open');
                if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'false');
                if (dropdownMenu)    dropdownMenu.setAttribute('aria-hidden', 'true');
            }

            // ── Tab pill click ────────────────────────────────────────────
            tabBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var fv    = (btn.getAttribute('data-filter') || '').trim();
                    var label = btn.textContent.trim();
                    syncTabs(fv);
                    syncDropdown(fv, label);
                    filterProducts(fv);
                });
            });

            // ── Dropdown trigger click ────────────────────────────────────
            if (dropdownTrigger) {
                dropdownTrigger.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var isOpen = dropdownWrapper.classList.toggle('is-open');
                    dropdownTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    if (dropdownMenu) dropdownMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                });
            }

            // ── Dropdown option click ─────────────────────────────────────
            dropdownOpts.forEach(function (opt) {
                opt.addEventListener('click', function () {
                    var fv    = (opt.getAttribute('data-filter') || '').trim();
                    var label = opt.textContent.trim();
                    syncDropdown(fv, label);
                    syncTabs(fv);
                    closeDropdown();
                    filterProducts(fv);
                });
            });

            // ── Close on outside click ────────────────────────────────────
            document.addEventListener('click', function (e) {
                if (dropdownWrapper && !dropdownWrapper.contains(e.target)) {
                    closeDropdown();
                }
            });

            // ── Close on Escape key ───────────────────────────────────────
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') closeDropdown();
            });
        });
    });

    // ── Entry Form Block: multi-step wizard (CF7 integration) ───────────
    document.addEventListener('DOMContentLoaded', function () {
        var wrapper = document.getElementById('efb-form-wrapper');
        if (!wrapper) return;

        // CF7 renders the form — find it inside our wrapper
        var form = wrapper.querySelector('.wpcf7-form');
        if (!form) return;

        var TOTAL_STEPS  = parseInt(wrapper.getAttribute('data-total-steps'), 10) || wrapper.querySelectorAll('.efb-step-item').length || 6;
        var currentStep  = 1;

        // Panels live inside the CF7 form (data-panel="1"–"6")
        var panels    = form.querySelectorAll('.efb-panel');
        var stepItems = wrapper.querySelectorAll('.efb-step-item');
        var trackFill = wrapper.querySelector('.efb-steps__track-fill');
        var btnBack   = document.getElementById('efb-back');
        var btnNext   = document.getElementById('efb-next');
        var btnSubmit = document.getElementById('efb-submit');

        // Preserve original submit button HTML (includes the arrow SVG) for restore after
        // a failed CF7 submission attempt.
        var submitOriginalHTML = btnSubmit ? btnSubmit.innerHTML : '';

        // Whether user has attempted to click Submit (controls consent error visibility)
        var submitAttempted = false;

        // ── Field helpers ─────────────────────────────────────────────────
        // Return all required input/select/textarea fields in a panel.
        // Excludes file inputs (upload is optional) and consent checkboxes.
        function getRequiredFields(panel) {
            if (!panel) return [];
            return Array.prototype.slice.call(
                panel.querySelectorAll('[aria-required="true"], input[required], select[required], textarea[required]')
            ).filter(function (f) { return f.type !== 'file'; });
        }

        // Validate a single field — returns { valid: bool, message: string }
        function validateField(field) {
            var val = (field.value || '').trim();

            // Empty check for all required field types
            if (!val) {
                return { valid: false, message: 'This field is required' };
            }

            // Type-specific format checks (only when value is non-empty)
            if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                return { valid: false, message: 'Please enter a valid email address' };
            }

            if (field.type === 'tel' && !/^[+\d][\d\s\-()+]{4,}$/.test(val)) {
                return { valid: false, message: 'Please enter a valid phone number' };
            }

            if (field.type === 'url' && !/^https?:\/\/.+/.test(val)) {
                return { valid: false, message: 'Please enter a valid URL (starting with https://)' };
            }

            // Select: required but placeholder option still selected
            if (field.tagName === 'SELECT' && val === '') {
                return { valid: false, message: 'Please select an option' };
            }

            return { valid: true, message: '' };
        }

        // Get the .efb-error span for a field
        function getErrorEl(field) {
            var wrap = field.closest('.efb-field');
            return wrap ? wrap.querySelector('.efb-error') : null;
        }

        // Apply error UI to a field
        function setFieldError(field, msg) {
            field.classList.add('has-error');
            field.setAttribute('aria-invalid', 'true');
            var errEl = getErrorEl(field);
            if (errEl) {
                errEl.textContent = msg;
                errEl.classList.add('is-visible');
            }
        }

        // Clear error UI from a field
        function clearFieldError(field) {
            field.classList.remove('has-error');
            field.removeAttribute('aria-invalid');
            var errEl = getErrorEl(field);
            if (errEl) {
                errEl.textContent = '';
                errEl.classList.remove('is-visible');
            }
        }

        // Clear all error UI in a panel without triggering new validation
        function clearPanelErrors(panel) {
            if (!panel) return;
            panel.querySelectorAll('.efb-input, select, textarea').forEach(function (f) {
                clearFieldError(f);
            });
            // Also clear any file-upload error messages
            panel.querySelectorAll('.efb-upload__error').forEach(function (el) {
                el.textContent = '';
                el.classList.remove('is-visible');
            });
        }

        // ── Step-level validation ──────────────────────────────────────────
        // surfaceErrors=true: update error UI on each field.
        // Returns true when all required fields in the panel are valid.
        function validateStep(n, surfaceErrors) {
            var panel  = form.querySelector('.efb-panel[data-panel="' + n + '"]');
            var fields = getRequiredFields(panel);
            var valid  = true;

            fields.forEach(function (field) {
                var result = validateField(field);
                if (!result.valid) {
                    valid = false;
                    if (surfaceErrors) setFieldError(field, result.message);
                } else {
                    if (surfaceErrors) clearFieldError(field);
                }
            });

            // Validate required file inputs separately (excluded from getRequiredFields).
            // CF7 adds aria-required="true" when [file*] tag is used.
            if (panel) {
                var requiredFiles = Array.prototype.slice.call(
                    panel.querySelectorAll('input[type="file"][aria-required="true"], input[type="file"][required]')
                );
                requiredFiles.forEach(function (fi) {
                    var hasFile = fi.files && fi.files.length > 0;
                    if (!hasFile) {
                        valid = false;
                        if (surfaceErrors) {
                            var zone = fi.closest('#efb-upload-zone') || fi.closest('.efb-upload') || fi.parentNode;
                            var errEl = zone ? zone.querySelector('.efb-upload__error') : null;
                            if (!errEl && zone) {
                                errEl = document.createElement('p');
                                errEl.className = 'efb-upload__error efb-error';
                                zone.appendChild(errEl);
                            }
                            if (errEl) {
                                errEl.textContent = 'Please upload a product image';
                                errEl.classList.add('is-visible');
                            }
                        }
                    } else {
                        if (surfaceErrors) {
                            var zone2 = fi.closest('#efb-upload-zone') || fi.closest('.efb-upload') || fi.parentNode;
                            var errEl2 = zone2 ? zone2.querySelector('.efb-upload__error') : null;
                            if (errEl2) {
                                errEl2.textContent = '';
                                errEl2.classList.remove('is-visible');
                            }
                        }
                    }
                });
            }

            return valid;
        }

        // Focus and scroll the first errored field in a panel into view
        function focusFirstError(panel) {
            if (!panel) return;
            var first = panel.querySelector('.has-error');
            if (first) {
                first.focus({ preventScroll: false });
                first.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        // ── Live Next-button state ──────────────────────────────────────
        // Silently disables/enables Next based on current step validity.
        // Never shows error messages — that only happens on blur or Next click.
        function updateNextButtonState() {
            if (!btnNext) return;
            btnNext.disabled = !validateStep(currentStep, false);
        }

        // ── Submit-button consent gate ───────────────────────────────────
        // Disables Submit until both consent checkboxes are ticked.
        function updateSubmitButtonState() {
            if (!btnSubmit) return;
            var checkboxes = form.querySelectorAll('.efb-consent input[type="checkbox"]');
            var allChecked = checkboxes.length > 0;
            checkboxes.forEach(function (cb) { if (!cb.checked) allChecked = false; });
            btnSubmit.disabled = !allChecked;

            // Only show the consent error message after the user has already
            // attempted to click Submit (avoids red text on first entry to step 6)
            if (submitAttempted) {
                var errEl = form.querySelector('#efb-consent-error');
                if (errEl) {
                    if (!allChecked) {
                        errEl.textContent = 'You must agree to all conditions before submitting';
                        errEl.classList.add('is-visible');
                    } else {
                        errEl.textContent = '';
                        errEl.classList.remove('is-visible');
                    }
                }
            }
        }

        // ── showStep ──────────────────────────────────────────────────────
        function showStep(n) {
            currentStep = n;
            panels.forEach(function (p) {
                p.classList.toggle('is-visible', parseInt(p.getAttribute('data-panel'), 10) === n);
            });

            // Step indicator states
            stepItems.forEach(function (item) {
                var num = parseInt(item.getAttribute('data-step-num'), 10);
                item.classList.remove('is-active', 'is-completed');
                if (num < n)  item.classList.add('is-completed');
                if (num === n) item.classList.add('is-active');
            });

            // Progress track fill
            var pct = ((n - 1) / (TOTAL_STEPS - 1)) * 100;
            trackFill.style.width = pct + '%';

            // Button visibility
            btnBack.style.visibility = n === 1 ? 'hidden' : 'visible';
            if (n === TOTAL_STEPS) {
                btnNext.style.display   = 'none';
                btnSubmit.style.display = 'inline-flex';
            } else {
                btnNext.style.display   = 'inline-flex';
                btnSubmit.style.display = 'none';
            }

            // Clear any stale error state from the panel we're entering
            var incomingPanel = form.querySelector('.efb-panel[data-panel="' + n + '"]');
            clearPanelErrors(incomingPanel);

            // Sync the correct button to match current field state
            if (n === TOTAL_STEPS) {
                populateReview();
                updateSubmitButtonState();
            } else {
                updateNextButtonState();
            }
        }

        // ── Delegated event listeners ─────────────────────────────────────

        // input — clear error immediately as user types, then refresh Next state
        form.addEventListener('input', function (e) {
            var field = e.target;
            if (field.type === 'file') return;
            if (field.classList.contains('has-error')) clearFieldError(field);
            updateNextButtonState();
        });

        // change — handles selects and consent checkboxes
        form.addEventListener('change', function (e) {
            var field = e.target;
            if (field.type === 'checkbox' && field.closest('.efb-consent')) {
                updateSubmitButtonState();
                return;
            }
            if (field.classList.contains('has-error')) clearFieldError(field);
            updateNextButtonState();
        });

        // focusout — surface per-field error when the user leaves a required field
        form.addEventListener('focusout', function (e) {
            var field = e.target;
            if (field.type === 'file') return;
            if (field.closest('.efb-consent')) return;
            var isRequired = field.getAttribute('aria-required') === 'true' || field.required;
            if (!isRequired) return;
            // Only validate fields that belong to the currently active panel
            var activePanel = form.querySelector('.efb-panel[data-panel="' + currentStep + '"]');
            if (!activePanel || !activePanel.contains(field)) return;

            var result = validateField(field);
            if (!result.valid) {
                setFieldError(field, result.message);
            } else {
                clearFieldError(field);
            }
            updateNextButtonState();
        });

        // ── Review population ─────────────────────────────────────────────
        function getVal(name) {
            var el = form.querySelector('[name="' + name + '"]');
            if (!el) return '';
            if (el.tagName === 'SELECT') {
                var opt = el.options[el.selectedIndex];
                // Skip blank placeholder options (include_blank renders value="")
                return (opt && opt.value !== '') ? opt.text : '';
            }
            if (el.type === 'file') return ''; // file inputs handled separately
            return el.value.trim();
        }

        function populateReview() {
            // Generic: find every element with data-review-fields and populate
            var reviewEls = form.querySelectorAll('[data-review-fields]');
            reviewEls.forEach(function (el) {
                var fields = el.getAttribute('data-review-fields').split(',');
                var sep    = el.getAttribute('data-review-sep') || ' ';
                var parts  = [];
                fields.forEach(function (name) {
                    var v = getVal(name.trim());
                    if (v) parts.push(v);
                });
                el.textContent = parts.length ? parts.join(sep) : '—';
            });

            // Also populate any 1:1 data-review keys (backward compat)
            var singleEls = form.querySelectorAll('[data-review]');
            singleEls.forEach(function (el) {
                if (el.hasAttribute('data-review-fields')) return; // already handled
                var key = el.getAttribute('data-review');
                var v   = getVal(key);
                el.textContent = v || '—';
            });

            // Populate product image in review from upload zone preview
            var reviewImg   = form.querySelector('.efb-review__product-img');
            var reviewNoImg = form.querySelector('.efb-review__no-image');
            if (reviewImg) {
                var uploadPreviewImg = form.querySelector('.efb-upload__preview img');
                // Check src: data URLs start with 'data:', blob URLs with 'blob:'
                var previewSrc = uploadPreviewImg ? uploadPreviewImg.src : '';
                var hasImage   = previewSrc && (previewSrc.indexOf('data:') === 0 || previewSrc.indexOf('blob:') === 0);
                if (hasImage) {
                    reviewImg.src           = previewSrc;
                    reviewImg.style.display = 'block';
                    if (reviewNoImg) reviewNoImg.style.display = 'none';
                } else {
                    reviewImg.style.display = 'none';
                    if (reviewNoImg) reviewNoImg.style.display = 'block';
                }
            }
        }

        // ── Navigation ────────────────────────────────────────────────────
        btnNext.addEventListener('click', function () {
            // Surface ALL errors for this step; block advance if any are invalid
            var valid = validateStep(currentStep, true);
            if (!valid) {
                var currentPanel = form.querySelector('.efb-panel[data-panel="' + currentStep + '"]');
                focusFirstError(currentPanel);
                return;
            }
            if (currentStep < TOTAL_STEPS) showStep(currentStep + 1);
        });

        btnBack.addEventListener('click', function () {
            if (currentStep > 1) showStep(currentStep - 1);
        });

        // Review step "Edit" buttons — jump back to a specific step
        form.querySelectorAll('.efb-review__edit').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var target = parseInt(btn.getAttribute('data-goto-step'), 10);
                if (target >= 1 && target <= TOTAL_STEPS) showStep(target);
            });
        });

        // ── Submit — trigger CF7's native form submission ─────────────────
        btnSubmit.addEventListener('click', function () {
            // Hard guard — should never be reachable while disabled, but belt-and-braces
            if (btnSubmit.disabled) return;

            submitAttempted = true;

            // Surface consent error and block if either checkbox is unchecked
            updateSubmitButtonState();
            if (btnSubmit.disabled) return;

            // Belt-and-braces: re-validate every prior step before submitting.
            // If a step is invalid (e.g. user edited a field on an earlier step),
            // jump back to it, surface its errors, and abort.
            for (var s = 1; s < TOTAL_STEPS; s++) {
                if (!validateStep(s, false)) {
                    showStep(s);
                    validateStep(s, true);
                    var badPanel = form.querySelector('.efb-panel[data-panel="' + s + '"]');
                    focusFirstError(badPanel);
                    return;
                }
            }

            // Disable to prevent double-submit and show in-flight state
            btnSubmit.disabled = true;
            btnSubmit.innerHTML = 'Submitting&hellip;';

            // Find CF7's hidden submit inside the form and click it
            var cf7Submit = form.querySelector('.efb-cf7-submit input[type="submit"], input.wpcf7-submit');
            if (cf7Submit) {
                cf7Submit.click();
            } else {
                // Fallback: dispatch submit event
                form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
        });

        // ── CF7 event listeners ────────────────────────────────────────────
        // CF7 fires custom DOM events on its <form> element's parent .wpcf7

        var cf7Wrapper = form.closest('.wpcf7');

        if (cf7Wrapper) {
            // Show thank-you card when no redirect URL is configured.
            function showThankyou() {
                var tyHeading = wrapper.getAttribute('data-thankyou-heading') || 'Thank You!';
                var tyText    = wrapper.getAttribute('data-thankyou-text')    || 'Your product entry has been submitted successfully. We\'ll be in touch soon.';
                var card = wrapper.closest('.efb-card') || wrapper;
                card.innerHTML =
                    '<div class="efb-thankyou">' +
                    '<div class="efb-thankyou__icon">' +
                    '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="32" fill="#FF2E93"/><path d="M20 33l8 8 16-16" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                    '</div>' +
                    '<h2 class="efb-thankyou__heading">' + tyHeading + '</h2>' +
                    '<p class="efb-thankyou__text">' + tyText + '</p>' +
                    '</div>';
            }

            function handleSuccessfulSubmission() {
                var redirectUrl = (wrapper.getAttribute('data-success-redirect-url') || '').trim();

                if (redirectUrl) {
                    window.location.assign(redirectUrl);
                    return;
                }

                showThankyou();
            }

            function restoreSubmitButton() {
                btnSubmit.innerHTML = submitOriginalHTML;
                updateSubmitButtonState();
            }

            // Mail sent successfully
            cf7Wrapper.addEventListener('wpcf7mailsent', handleSuccessfulSubmission);

            // Mail failed on server - restore button and leave CF7's error visible.
            cf7Wrapper.addEventListener('wpcf7mailfailed', restoreSubmitButton);

            // CF7 server-side validation failed — restore button, re-check consent state
            cf7Wrapper.addEventListener('wpcf7invalid', restoreSubmitButton);

            // Spam detected — restore button, re-check consent state
            cf7Wrapper.addEventListener('wpcf7spam', restoreSubmitButton);
        }

        // ── File upload UX ───────────────────────────────────────────────
        var uploadZone  = form.querySelector('#efb-upload-zone');
        var fileInput   = form.querySelector('[name="productImage"]');
        var placeholder = uploadZone ? uploadZone.querySelector('.efb-upload__placeholder') : null;
        var preview     = uploadZone ? uploadZone.querySelector('.efb-upload__preview') : null;
        var previewImg  = preview ? preview.querySelector('img') : null;
        var removeBtn   = preview ? preview.querySelector('.efb-upload__remove') : null;

        if (uploadZone && fileInput) {
            // ── Click to browse ──────────────────────────────────────────
            // CF7's file input is visually hidden (clip). Clicking the zone
            // or the browse button opens the native file picker.
            uploadZone.addEventListener('click', function (e) {
                if (e.target.classList.contains('efb-upload__remove')) return;
                fileInput.click();
            });

            // ── Drag-and-drop ────────────────────────────────────────────
            // relatedTarget boundary check: reliable cross-browser method.
            // dragenter/dragleave on child elements are ignored — we only
            // react when the drag cursor crosses the zone boundary.

            uploadZone.addEventListener('dragenter', function (e) {
                e.preventDefault();
                if (!uploadZone.contains(e.relatedTarget)) {
                    uploadZone.classList.add('is-dragover');
                }
            });

            uploadZone.addEventListener('dragover', function (e) {
                e.preventDefault(); // Required to allow drop
            });

            uploadZone.addEventListener('dragleave', function (e) {
                e.preventDefault();
                if (!uploadZone.contains(e.relatedTarget)) {
                    uploadZone.classList.remove('is-dragover');
                }
            });

            uploadZone.addEventListener('drop', function (e) {
                e.preventDefault();
                uploadZone.classList.remove('is-dragover');

                var files = e.dataTransfer.files;
                if (!files.length) return;

                // Client-side type check
                var file = files[0];
                if (!file.type.match(/^image\/(jpeg|png)$/)) return;

                // Use DataTransfer API to assign file to the hidden CF7 input
                var dt = new DataTransfer();
                dt.items.add(file);
                fileInput.files = dt.files;

                // Dispatch change event so CF7 picks up the file
                fileInput.dispatchEvent(new Event('change', { bubbles: true }));

                showPreview(file);
            });

            fileInput.addEventListener('change', function () {
                if (fileInput.files.length) showPreview(fileInput.files[0]);
            });

            function showPreview(file) {
                if (!file || !file.type.match('image.*')) return;
                var reader = new FileReader();
                reader.onload = function (e) {
                    if (previewImg) previewImg.src = e.target.result;
                    if (placeholder) placeholder.style.display = 'none';
                    if (preview)     preview.style.display = 'block';
                };
                reader.readAsDataURL(file);
            }

            if (removeBtn) {
                removeBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    fileInput.value = '';
                    if (previewImg)  previewImg.src = '';
                    if (placeholder) placeholder.style.display = 'flex';
                    if (preview)     preview.style.display = 'none';
                });
            }
        }

        // ── Initialise: intro panel gate or direct form launch ──────────
        var introPanel       = document.getElementById('efb-intro-panel');
        var introAgree       = document.getElementById('efb-intro-agree');
        var introContinue    = document.getElementById('efb-intro-continue');
        var introPanelActive = wrapper.getAttribute('data-entry-info') === '1';
        var efbStepsEl       = wrapper.querySelector('.efb-steps');
        var efbNavEl         = wrapper.querySelector('.efb-nav');

        if (introPanel && introPanelActive) {
            // Steps and nav are hidden via inline PHP style — revealed after Continue.

            // Checkbox enables / disables the Continue button.
            introAgree.addEventListener('change', function () {
                introContinue.disabled = !this.checked;
            });

            // Continue click: hide intro, show form at step 1.
            introContinue.addEventListener('click', function () {
                if (!introAgree.checked) return;
                introPanel.style.display = 'none';
                if (efbStepsEl) efbStepsEl.style.display = '';
                if (efbNavEl)   efbNavEl.style.display   = '';
                showStep(1);
            });
        } else {
            // No intro panel — show steps / nav and jump straight to step 1.
            if (efbStepsEl) efbStepsEl.style.display = '';
            if (efbNavEl)   efbNavEl.style.display   = '';
            showStep(1);
        }
    });

    // ── Gallery Block: lightbox viewer ───────────────────────────────────
    document.addEventListener('DOMContentLoaded', function () {
        var galleryBlocks = document.querySelectorAll('.page-block.gallery_block');

        galleryBlocks.forEach(function (section) {
            var lightbox     = section.querySelector('.gb-lightbox');
            var mediaEl      = lightbox ? lightbox.querySelector('.gb-lightbox__media') : null;
            var captionEl    = lightbox ? lightbox.querySelector('.gb-lightbox__caption') : null;
            var counterEl    = lightbox ? lightbox.querySelector('.gb-lightbox__counter') : null;
            var prevBtn      = lightbox ? lightbox.querySelector('.gb-lightbox__prev') : null;
            var nextBtn      = lightbox ? lightbox.querySelector('.gb-lightbox__next') : null;
            var closeBtn     = lightbox ? lightbox.querySelector('.gb-lightbox__close') : null;
            var backdrop     = lightbox ? lightbox.querySelector('.gb-lightbox__backdrop') : null;

            if (!lightbox || !mediaEl) return;

            var galleryData   = [];
            var showCaptions  = lightbox.getAttribute('data-gb-show-captions') === '1';
            var showCounter   = lightbox.getAttribute('data-gb-show-counter') === '1';
            var currentIndex  = 0;
            var isOpen        = false;

            // Touch tracking for swipe navigation
            var touchStartX = 0;
            var touchEndX   = 0;
            var touchStartY = 0;
            var touchEndY   = 0;

            // ── Zoom state (images only) ─────────────────────────────────
            var zoomScale    = 1;
            var zoomX        = 0;
            var zoomY        = 0;
            var MIN_ZOOM     = 1;
            var MAX_ZOOM     = 4;
            var isPanning    = false;
            var panStartX    = 0;
            var panStartY    = 0;
            var panOriginX   = 0;
            var panOriginY   = 0;
            // Pinch state
            var initialPinchDist = 0;
            var pinchStartScale  = 1;

            // Parse gallery data from JSON attribute
            try {
                galleryData = JSON.parse(lightbox.getAttribute('data-gb-gallery') || '[]');
            } catch (e) {
                return;
            }

            if (!galleryData.length) return;

            // ── Zoom helpers ─────────────────────────────────────────────
            function isCurrentImage() {
                var item = galleryData[currentIndex];
                return item && item.type !== 'video';
            }

            function isZoomed() {
                return zoomScale > 1.01;
            }

            function resetZoom() {
                zoomScale = 1;
                zoomX = 0;
                zoomY = 0;
                applyZoom(true);
                lightbox.classList.remove('is-zoomed');
            }

            function clampPan() {
                var img = mediaEl.querySelector('img');
                if (!img) return;

                var rect = mediaEl.getBoundingClientRect();
                var imgW = img.naturalWidth ? Math.min(img.naturalWidth, rect.width) : rect.width;
                var imgH = img.naturalHeight ? Math.min(img.naturalHeight, rect.height) : rect.height;

                // Scaled dimensions vs container
                var scaledW = imgW * zoomScale;
                var scaledH = imgH * zoomScale;

                var maxPanX = Math.max(0, (scaledW - rect.width) / 2 / zoomScale);
                var maxPanY = Math.max(0, (scaledH - rect.height) / 2 / zoomScale);

                zoomX = Math.max(-maxPanX, Math.min(maxPanX, zoomX));
                zoomY = Math.max(-maxPanY, Math.min(maxPanY, zoomY));
            }

            function applyZoom(smooth) {
                var img = mediaEl.querySelector('img');
                if (!img) return;

                if (smooth) {
                    img.classList.remove('is-panning');
                } else {
                    img.classList.add('is-panning');
                }

                img.style.transform = 'scale(' + zoomScale + ') translate(' + zoomX + 'px, ' + zoomY + 'px)';

                if (isZoomed()) {
                    img.classList.add('is-zoomed');
                    lightbox.classList.add('is-zoomed');
                } else {
                    img.classList.remove('is-zoomed');
                    lightbox.classList.remove('is-zoomed');
                }
            }

            function zoomAtPoint(newScale, clientX, clientY) {
                var img = mediaEl.querySelector('img');
                if (!img) return;

                newScale = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, newScale));

                if (newScale <= MIN_ZOOM) {
                    resetZoom();
                    return;
                }

                var rect = img.getBoundingClientRect();
                // Cursor position relative to image center (in unscaled coords)
                var cx = (clientX - rect.left - rect.width / 2) / zoomScale;
                var cy = (clientY - rect.top - rect.height / 2) / zoomScale;

                // Adjust translate to keep the point under cursor stable
                var ratio = 1 - newScale / zoomScale;
                zoomX += cx * ratio;
                zoomY += cy * ratio;

                zoomScale = newScale;
                clampPan();
                applyZoom(false);
            }

            // ── Scroll wheel zoom (images only) ─────────────────────────
            mediaEl.addEventListener('wheel', function (e) {
                if (!isOpen || !isCurrentImage()) return;

                e.preventDefault();
                var delta = e.deltaY > 0 ? -0.25 : 0.25;
                zoomAtPoint(zoomScale + delta, e.clientX, e.clientY);
            }, { passive: false });

            // ── Double-click to toggle zoom (images only) ────────────────
            var lastTapTime = 0;
            mediaEl.addEventListener('dblclick', function (e) {
                if (!isOpen || !isCurrentImage()) return;
                e.preventDefault();

                if (isZoomed()) {
                    resetZoom();
                } else {
                    zoomAtPoint(2, e.clientX, e.clientY);
                }
            });

            // ── Mouse drag to pan when zoomed ────────────────────────────
            mediaEl.addEventListener('mousedown', function (e) {
                if (!isOpen || !isCurrentImage() || !isZoomed()) return;
                if (e.button !== 0) return; // left click only

                e.preventDefault();
                isPanning = true;
                panStartX = e.clientX;
                panStartY = e.clientY;
                panOriginX = zoomX;
                panOriginY = zoomY;
                mediaEl.classList.add('is-grabbing');
            });

            document.addEventListener('mousemove', function (e) {
                if (!isPanning) return;

                var dx = (e.clientX - panStartX) / zoomScale;
                var dy = (e.clientY - panStartY) / zoomScale;
                zoomX = panOriginX + dx;
                zoomY = panOriginY + dy;
                clampPan();
                applyZoom(false);
            });

            document.addEventListener('mouseup', function () {
                if (!isPanning) return;
                isPanning = false;
                mediaEl.classList.remove('is-grabbing');
            });

            // ── Touch: pinch-to-zoom + pan + double-tap ──────────────────
            lightbox.addEventListener('touchstart', function (e) {
                touchStartX = e.changedTouches[0].screenX;
                touchStartY = e.changedTouches[0].screenY;

                // Pinch start (two fingers)
                if (e.touches.length === 2 && isCurrentImage()) {
                    var dx = e.touches[0].clientX - e.touches[1].clientX;
                    var dy = e.touches[0].clientY - e.touches[1].clientY;
                    initialPinchDist = Math.hypot(dx, dy);
                    pinchStartScale = zoomScale;
                }

                // Double-tap detection
                if (e.touches.length === 1 && isCurrentImage()) {
                    var now = Date.now();
                    if (now - lastTapTime < 300) {
                        e.preventDefault();
                        if (isZoomed()) {
                            resetZoom();
                        } else {
                            zoomAtPoint(2, e.touches[0].clientX, e.touches[0].clientY);
                        }
                        lastTapTime = 0;
                    } else {
                        lastTapTime = now;
                    }

                    // Pan start when zoomed
                    if (isZoomed()) {
                        isPanning = true;
                        panStartX = e.touches[0].clientX;
                        panStartY = e.touches[0].clientY;
                        panOriginX = zoomX;
                        panOriginY = zoomY;
                    }
                }
            }, { passive: false });

            lightbox.addEventListener('touchmove', function (e) {
                // Pinch zoom
                if (e.touches.length === 2 && isCurrentImage() && initialPinchDist > 0) {
                    e.preventDefault();
                    var dx = e.touches[0].clientX - e.touches[1].clientX;
                    var dy = e.touches[0].clientY - e.touches[1].clientY;
                    var dist = Math.hypot(dx, dy);
                    var newScale = pinchStartScale * (dist / initialPinchDist);

                    var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                    var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                    zoomAtPoint(newScale, midX, midY);
                    return;
                }

                // Single-finger pan when zoomed
                if (e.touches.length === 1 && isPanning && isZoomed()) {
                    e.preventDefault();
                    var tdx = (e.touches[0].clientX - panStartX) / zoomScale;
                    var tdy = (e.touches[0].clientY - panStartY) / zoomScale;
                    zoomX = panOriginX + tdx;
                    zoomY = panOriginY + tdy;
                    clampPan();
                    applyZoom(false);
                }
            }, { passive: false });

            lightbox.addEventListener('touchend', function (e) {
                // Reset pinch tracking
                if (e.touches.length < 2) {
                    initialPinchDist = 0;
                }

                // End panning
                if (e.touches.length === 0) {
                    var wasPanning = isPanning && isZoomed();
                    isPanning = false;

                    // Swipe navigation — only when NOT zoomed
                    if (!isZoomed()) {
                        touchEndX = e.changedTouches[0].screenX;
                        touchEndY = e.changedTouches[0].screenY;

                        var diffX = touchEndX - touchStartX;
                        var diffY = touchEndY - touchStartY;

                        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
                            if (diffX < 0) {
                                goNext();
                            } else {
                                goPrev();
                            }
                        }
                    }
                }
            }, { passive: true });

            // ── Open lightbox ────────────────────────────────────────────
            function openLightbox(index) {
                currentIndex = index;
                renderItem(currentIndex);

                // Move to body for true fullscreen (avoids ancestor clipping)
                document.body.appendChild(lightbox);

                lightbox.removeAttribute('hidden');
                // Force reflow for transition
                lightbox.getBoundingClientRect();
                lightbox.classList.add('is-open');
                isOpen = true;

                document.body.style.overflow = 'hidden';

                // Focus trap
                closeBtn.focus();

                // Preload adjacent
                preloadAdjacent(currentIndex);
            }

            // ── Close lightbox ───────────────────────────────────────────
            function closeLightbox() {
                if (!isOpen) return;

                // Pause any playing video
                var vid = mediaEl.querySelector('video');
                if (vid) vid.pause();

                // Reset zoom state
                resetZoom();

                lightbox.classList.remove('is-open');
                isOpen = false;

                document.body.style.overflow = '';

                // After transition, hide and return to section DOM
                setTimeout(function () {
                    if (!isOpen) {
                        lightbox.setAttribute('hidden', '');
                        mediaEl.innerHTML = '';
                        section.appendChild(lightbox);
                    }
                }, 300);

                // Return focus to the grid item
                var trigger = section.querySelector('.gb-item[data-gb-index="' + currentIndex + '"]');
                if (trigger) trigger.focus();
            }

            // ── Navigate ─────────────────────────────────────────────────
            function goTo(index) {
                // Pause any current video
                var vid = mediaEl.querySelector('video');
                if (vid) vid.pause();

                // Reset zoom on navigation
                resetZoom();

                currentIndex = (index + galleryData.length) % galleryData.length;
                renderItem(currentIndex);
                preloadAdjacent(currentIndex);
            }

            function goNext() { goTo(currentIndex + 1); }
            function goPrev() { goTo(currentIndex - 1); }

            // ── Render item in lightbox ──────────────────────────────────
            function renderItem(index) {
                var item = galleryData[index];
                if (!item) return;

                mediaEl.innerHTML = '';

                if (item.type === 'video') {
                    var video = document.createElement('video');
                    video.src = item.src;
                    video.controls = true;
                    video.autoplay = true;
                    video.playsInline = true;
                    if (item.poster) video.poster = item.poster;
                    video.setAttribute('aria-label', item.caption || 'Gallery video');
                    mediaEl.appendChild(video);
                } else {
                    var img = document.createElement('img');
                    img.src = item.src;
                    img.alt = item.alt || item.caption || '';
                    img.setAttribute('draggable', 'false');
                    mediaEl.appendChild(img);
                }

                // Caption
                if (captionEl && showCaptions) {
                    captionEl.textContent = item.caption || '';
                    captionEl.style.display = item.caption ? '' : 'none';
                }

                // Counter
                if (counterEl && showCounter) {
                    counterEl.textContent = (index + 1) + ' / ' + galleryData.length;
                }
            }

            // ── Preload adjacent images ──────────────────────────────────
            function preloadAdjacent(index) {
                [-1, 1].forEach(function (offset) {
                    var i = (index + offset + galleryData.length) % galleryData.length;
                    var item = galleryData[i];
                    if (item && item.type === 'image' && item.src) {
                        var link = document.createElement('link');
                        link.rel = 'prefetch';
                        link.as = 'image';
                        link.href = item.src;
                        // Only add if not already prefetched
                        if (!document.querySelector('link[href="' + item.src + '"]')) {
                            document.head.appendChild(link);
                        }
                    }
                });
            }

            // ── Event: click grid item ───────────────────────────────────
            var items = section.querySelectorAll('.gb-item');
            items.forEach(function (item) {
                item.addEventListener('click', function () {
                    var idx = parseInt(item.getAttribute('data-gb-index'), 10);
                    openLightbox(idx);
                });

                item.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        var idx = parseInt(item.getAttribute('data-gb-index'), 10);
                        openLightbox(idx);
                    }
                });
            });

            // ── Event: navigation buttons ────────────────────────────────
            if (prevBtn) prevBtn.addEventListener('click', goPrev);
            if (nextBtn) nextBtn.addEventListener('click', goNext);
            if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
            if (backdrop) {
                backdrop.addEventListener('click', function () {
                    // Don't close on backdrop click when zoomed (avoids accidental close while panning)
                    if (!isZoomed()) closeLightbox();
                });
            }

            // ── Event: keyboard ──────────────────────────────────────────
            document.addEventListener('keydown', function (e) {
                if (!isOpen) return;

                switch (e.key) {
                    case 'Escape':
                        if (isZoomed()) {
                            resetZoom();
                        } else {
                            closeLightbox();
                        }
                        break;
                    case 'ArrowLeft':
                        e.preventDefault();
                        if (!isZoomed()) goPrev();
                        break;
                    case 'ArrowRight':
                        e.preventDefault();
                        if (!isZoomed()) goNext();
                        break;
                    case '0':
                        // Reset zoom with 0 key
                        resetZoom();
                        break;
                }
            });
        });
    });

    // ─────────────────────────────────────────────────────────────────────────
    // Hero 2 Block — Fractal Gradient Canvas Animation
    //
    // When background_type === 'fractal_gradient', three ACF colour values are
    // passed as data attributes on <canvas class="h2b-fractal-canvas">.
    // This function creates 3 animated blobs per colour (9 blobs total), each
    // drifting in a sinusoidal path. Blobs are drawn as radial gradients and
    // composited with 'lighter' (additive) blending so overlapping regions mix
    // like light — creating an organic, jewel-toned fractal shimmer effect.
    // ─────────────────────────────────────────────────────────────────────────
    (function initH2BFractalGradient() {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Parse a 6-digit hex colour string → {r, g, b}
        function hexToRgb(hex) {
            var clean = hex.replace('#', '');
            if (clean.length === 3) {
                clean = clean[0]+clean[0]+clean[1]+clean[1]+clean[2]+clean[2];
            }
            return {
                r: parseInt(clean.slice(0, 2), 16),
                g: parseInt(clean.slice(2, 4), 16),
                b: parseInt(clean.slice(4, 6), 16)
            };
        }

        // Build 3 blob descriptors for a given {r,g,b} colour with random but
        // well-distributed starting phases so they never all clump together.
        function buildBlobs(rgb, index) {
            var blobs = [];
            for (var i = 0; i < 3; i++) {
                var slot = index * 3 + i; // 0-8 — gives each blob a unique sector
                blobs.push({
                    rgb     : rgb,
                    // Position: centre + radius * sin/cos
                    cxRatio : 0.2 + (slot % 3) * 0.3,   // 0.2 / 0.5 / 0.8 across width
                    cyRatio : 0.2 + Math.floor(slot / 3) * 0.3, // 0.2 / 0.5 / 0.8 down height
                    rxRatio : 0.18 + (slot * 0.031) % 0.14, // x-orbit radius as fraction of w
                    ryRatio : 0.15 + (slot * 0.027) % 0.12, // y-orbit radius as fraction of h
                    speedX  : 0.00018 + (slot * 0.000031),  // radians per ms
                    speedY  : 0.00015 + (slot * 0.000027),
                    phaseX  : slot * 0.71,                  // stagger phases (prime-ish step)
                    phaseY  : slot * 1.13,
                    rRatio  : 0.38 + (slot * 0.021) % 0.18  // blob radius as fraction of w
                });
            }
            return blobs;
        }

        function initCanvas(canvas) {
            var ctx    = canvas.getContext('2d');
            var colA   = hexToRgb(canvas.dataset.colorA || '#4B1F73');
            var colB   = hexToRgb(canvas.dataset.colorB || '#7B3FA0');
            var colC   = hexToRgb(canvas.dataset.colorC || '#FF2E93');

            var allBlobs = [].concat(
                buildBlobs(colA, 0),
                buildBlobs(colB, 1),
                buildBlobs(colC, 2)
            );

            var raf    = null;
            var paused = false;

            // Resize canvas pixel dimensions to match layout size
            function resize() {
                var parent = canvas.parentElement;
                canvas.width  = parent.offsetWidth  || 800;
                canvas.height = parent.offsetHeight || 540;
            }

            var ro = new ResizeObserver(function() { resize(); });
            ro.observe(canvas.parentElement);
            resize();

            function draw(ts) {
                if (paused) { raf = requestAnimationFrame(draw); return; }

                var w = canvas.width;
                var h = canvas.height;

                // Flush with near-black purple base so blobs glow against dark
                ctx.globalCompositeOperation = 'source-over';
                ctx.fillStyle = '#0d0020';
                ctx.fillRect(0, 0, w, h);

                // Additive blending: where blobs overlap, colours merge like light
                ctx.globalCompositeOperation = 'lighter';

                for (var i = 0; i < allBlobs.length; i++) {
                    var b  = allBlobs[i];
                    var cx = (b.cxRatio * w) + (b.rxRatio * w) * Math.sin(ts * b.speedX + b.phaseX);
                    var cy = (b.cyRatio * h) + (b.ryRatio * h) * Math.cos(ts * b.speedY + b.phaseY);
                    var r  = b.rRatio * w;

                    var grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
                    grad.addColorStop(0,   'rgba(' + b.rgb.r + ',' + b.rgb.g + ',' + b.rgb.b + ',0.72)');
                    grad.addColorStop(0.45,'rgba(' + b.rgb.r + ',' + b.rgb.g + ',' + b.rgb.b + ',0.30)');
                    grad.addColorStop(1,   'rgba(' + b.rgb.r + ',' + b.rgb.g + ',' + b.rgb.b + ',0)');

                    ctx.beginPath();
                    ctx.arc(cx, cy, r, 0, Math.PI * 2);
                    ctx.fillStyle = grad;
                    ctx.fill();
                }

                raf = requestAnimationFrame(draw);
            }

            // Respect prefers-reduced-motion: draw a single static frame instead
            if (reducedMotion) {
                draw(0);
                return;
            }

            // Pause when the canvas scrolls out of the viewport
            var io = new IntersectionObserver(function(entries) {
                paused = !entries[0].isIntersecting;
            }, { threshold: 0 });
            io.observe(canvas);

            raf = requestAnimationFrame(draw);
        }

        document.addEventListener('DOMContentLoaded', function() {
            var canvases = document.querySelectorAll('.h2b-fractal-canvas');
            for (var i = 0; i < canvases.length; i++) {
                initCanvas(canvases[i]);
            }
        });
    })();

    // ─────────────────────────────────────────────────────────────────────────
    // Vote Now Block — responsive motion and the mobile sticky CTA
    // ─────────────────────────────────────────────────────────────────────────
    (function initVoteNowBlocks() {
        var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
        var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
        var mobileViewport = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
        var stickyRecords = [];
        var stickyFrame = null;
        var stickyTrackingReady = false;

        function addMediaListener(mediaQuery, callback) {
            if (!mediaQuery) return;

            if (typeof mediaQuery.addEventListener === 'function') {
                mediaQuery.addEventListener('change', callback);
            } else if (typeof mediaQuery.addListener === 'function') {
                mediaQuery.addListener(callback);
            }
        }

        function viewportIsMobile() {
            return mobileViewport ? mobileViewport.matches : window.innerWidth < 768;
        }

        function setStickyBadgeVisibility(record, visible) {
            record.badge.hidden = !visible;

            if (visible) {
                record.badge.removeAttribute('aria-hidden');
                record.badge.removeAttribute('tabindex');
            } else {
                record.badge.setAttribute('aria-hidden', 'true');
                record.badge.setAttribute('tabindex', '-1');
            }
        }

        function updateStickyBadges() {
            stickyFrame = null;

            var isMobile = viewportIsMobile();
            var candidate = null;
            var blockIsVisible = false;

            stickyRecords.forEach(function(record) {
                var bounds = record.block.getBoundingClientRect();

                setStickyBadgeVisibility(record, false);

                if (bounds.bottom > 0 && bounds.top < window.innerHeight) {
                    blockIsVisible = true;
                }

                if (bounds.bottom <= 0) {
                    candidate = record;
                }
            });

            if (isMobile && !blockIsVisible && candidate) {
                setStickyBadgeVisibility(candidate, true);
            }
        }

        function scheduleStickyUpdate() {
            if (stickyFrame) return;

            stickyFrame = window.requestAnimationFrame(updateStickyBadges);
        }

        function initialiseStickyBadges() {
            if (stickyTrackingReady) return;

            var blocks = document.querySelectorAll('.vote_now[data-vnow-id]');

            document.querySelectorAll('.vnow-sticky-badge[data-vnow-sticky-for]').forEach(function(badge) {
                var target = badge.getAttribute('data-vnow-sticky-for');
                var matchingBlock = null;

                blocks.forEach(function(block) {
                    if (block.getAttribute('data-vnow-id') === target) {
                        matchingBlock = block;
                    }
                });

                if (matchingBlock) {
                    stickyRecords.push({ block: matchingBlock, badge: badge });
                }
            });

            if (!stickyRecords.length) return;

            stickyTrackingReady = true;

            if ('IntersectionObserver' in window) {
                var stickyObserver = new IntersectionObserver(scheduleStickyUpdate, { threshold: 0 });

                stickyRecords.forEach(function(record) {
                    stickyObserver.observe(record.block);
                });
            } else {
                window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
            }

            window.addEventListener('resize', scheduleStickyUpdate, { passive: true });
            addMediaListener(mobileViewport, scheduleStickyUpdate);
            scheduleStickyUpdate();
        }

        function initialiseBlock(block) {
            if (block.getAttribute('data-vnow-ready') === 'true') return;

            block.setAttribute('data-vnow-ready', 'true');
            block.classList.add('vnow-enhanced');

            var isVisible = false;
            var hasEntered = false;
            var pointerFrame = null;
            var pointerX = 0;
            var pointerY = 0;
            var replayLocked = false;
            var replayTimer = null;
            var lastSequenceStarted = 0;
            var cta = block.querySelector('.vnow-cta');

            function motionIsReduced() {
                return Boolean(reducedMotion && reducedMotion.matches);
            }

            function interactionMotionIsDisabled() {
                return motionIsReduced() || viewportIsMobile();
            }

            function pointerIsFine() {
                return Boolean(finePointer && finePointer.matches);
            }

            function resetDepth() {
                if (pointerFrame) {
                    window.cancelAnimationFrame(pointerFrame);
                    pointerFrame = null;
                }

                block.style.setProperty('--vnow-shift-x', '0px');
                block.style.setProperty('--vnow-shift-y', '0px');
            }

            function markEntered() {
                if (hasEntered) return;
                hasEntered = true;
                lastSequenceStarted = Date.now();

                window.requestAnimationFrame(function() {
                    block.classList.add('has-entered');
                });
            }

            function replaySequence() {
                if (!hasEntered || !isVisible || interactionMotionIsDisabled() || replayLocked || Date.now() - lastSequenceStarted < 2300) return;

                replayLocked = true;
                lastSequenceStarted = Date.now();
                block.classList.remove('is-replaying');
                // Force a style flush so the duplicated replay keyframes restart
                // even when the previous replay class remains on the block.
                void block.offsetWidth;
                block.classList.add('is-replaying', 'is-replay-active');

                if (replayTimer) window.clearTimeout(replayTimer);
                replayTimer = window.setTimeout(function() {
                    replayLocked = false;
                    block.classList.remove('is-replay-active');
                }, 2300);
            }

            function setVisibility(visible, shouldEnter) {
                isVisible = visible;
                block.classList.toggle('is-in-view', visible);

                if (visible && shouldEnter) markEntered();
                if (!visible) resetDepth();
            }

            function syncMotionPreference() {
                var reduce = motionIsReduced();
                var mobile = viewportIsMobile();
                block.classList.toggle('is-reduced-motion', reduce);
                block.classList.toggle('is-mobile-layout', mobile);

                if (reduce) {
                    markEntered();
                }

                if (reduce || mobile) {
                    resetDepth();
                    replayLocked = false;
                    block.classList.remove('is-replaying', 'is-replay-active');
                    if (replayTimer) {
                        window.clearTimeout(replayTimer);
                        replayTimer = null;
                    }
                }
            }

            function updateDepth() {
                pointerFrame = null;

                if (!isVisible || interactionMotionIsDisabled() || !pointerIsFine()) {
                    resetDepth();
                    return;
                }

                var bounds = block.getBoundingClientRect();
                var xRatio = Math.max(-1, Math.min(1, (pointerX - bounds.left - (bounds.width / 2)) / (bounds.width / 2)));
                var yRatio = Math.max(-1, Math.min(1, (pointerY - bounds.top - (bounds.height / 2)) / (bounds.height / 2)));

                block.style.setProperty('--vnow-shift-x', (xRatio * 4).toFixed(2) + 'px');
                block.style.setProperty('--vnow-shift-y', (yRatio * 4).toFixed(2) + 'px');
            }

            block.addEventListener('pointermove', function(event) {
                if (!isVisible || interactionMotionIsDisabled() || !pointerIsFine()) return;

                pointerX = event.clientX;
                pointerY = event.clientY;

                if (!pointerFrame) {
                    pointerFrame = window.requestAnimationFrame(updateDepth);
                }
            });
            block.addEventListener('pointerleave', resetDepth);

            if (cta) {
                cta.addEventListener('mouseenter', function() {
                    if (pointerIsFine()) replaySequence();
                });
                cta.addEventListener('focus', replaySequence);
            }

            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        setVisibility(entry.isIntersecting, entry.intersectionRatio >= 0.24);
                    });
                }, {
                    threshold: [0, 0.24],
                    rootMargin: '0px 0px -8% 0px'
                });

                observer.observe(block);
            } else {
                setVisibility(true, true);
            }

            addMediaListener(reducedMotion, syncMotionPreference);
            addMediaListener(finePointer, resetDepth);
            addMediaListener(mobileViewport, syncMotionPreference);
            syncMotionPreference();
        }

        function initialiseAll() {
            document.querySelectorAll('.vote_now').forEach(initialiseBlock);
            initialiseStickyBadges();
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initialiseAll);
        } else {
            initialiseAll();
        }
    })();

    // ─────────────────────────────────────────────────────────────────────────
    // Ticket Booking — background video + tear-away success sequence
    // ─────────────────────────────────────────────────────────────────────────
    (function initTicketBooking() {
        function playAnimation(element, keyframes, options, registry) {
            if (!element || typeof element.animate !== 'function') {
                return Promise.resolve();
            }

            return new Promise(function(resolve) {
                var animation;

                try {
                    animation = element.animate(keyframes, options);
                } catch (error) {
                    resolve();
                    return;
                }

                var complete = false;
                registry.push(animation);

                function finish() {
                    if (complete) return;
                    complete = true;

                    var index = registry.indexOf(animation);
                    if (index !== -1) registry.splice(index, 1);

                    animation.cancel();
                    resolve();
                }

                animation.addEventListener('finish', finish, { once: true });
                animation.addEventListener('cancel', finish, { once: true });
            });
        }

        function initialiseBackgroundVideo(block) {
            var video = block.querySelector('.tbk-background__video');
            if (!video) return;

            var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
            var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            var isVisible = !('IntersectionObserver' in window);

            function mustStayStatic() {
                return Boolean((reducedMotion && reducedMotion.matches) || (connection && connection.saveData));
            }

            function showStaticFallback() {
                video.pause();
                block.classList.remove('is-video-playing');
                block.classList.add('is-video-static');
            }

            function attemptPlayback() {
                if (mustStayStatic()) {
                    showStaticFallback();
                    return;
                }

                block.classList.remove('is-video-static');

                if (!isVisible) {
                    video.pause();
                    return;
                }

                var playback = video.play();
                if (playback && typeof playback.catch === 'function') {
                    playback.catch(showStaticFallback);
                }
            }

            video.addEventListener('playing', function() {
                if (mustStayStatic()) {
                    showStaticFallback();
                    return;
                }

                block.classList.remove('is-video-static');
                block.classList.add('is-video-playing');
            });

            video.addEventListener('error', showStaticFallback);

            if ('IntersectionObserver' in window) {
                var videoObserver = new IntersectionObserver(function(entries) {
                    isVisible = entries[0].isIntersecting;
                    attemptPlayback();
                }, { threshold: 0.05 });
                videoObserver.observe(block);
            } else {
                attemptPlayback();
            }

            if (reducedMotion) {
                if (typeof reducedMotion.addEventListener === 'function') {
                    reducedMotion.addEventListener('change', attemptPlayback);
                } else if (typeof reducedMotion.addListener === 'function') {
                    reducedMotion.addListener(attemptPlayback);
                }
            }

            if (connection && typeof connection.addEventListener === 'function') {
                connection.addEventListener('change', attemptPlayback);
            }

            if (mustStayStatic()) showStaticFallback();
        }

        function initialiseSuccessAnimation(block) {
            var shell       = block.querySelector('.tbk-shell');
            var ticket      = block.querySelector('.tbk-ticket');
            var seam        = block.querySelector('.tbk-tear-seam');
            var seamLine    = block.querySelector('.tbk-tear-seam__line');
            var seamProgress= block.querySelector('.tbk-tear-seam__progress');
            var scissors    = block.querySelector('.tbk-scissors');
            var formCard    = block.querySelector('.tbk-form-card');
            var formContent = block.querySelector('.tbk-form-card__content');
            var cf7Wrapper  = block.querySelector('.tbk-form-wrap .wpcf7');
            var success     = block.querySelector('.tbk-success');

            if (!shell || !ticket || !seam || !seamLine || !seamProgress || !scissors || !formCard || !cf7Wrapper || !success) {
                return;
            }

            var state = 'idle';
            var animations = [];
            var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
            var desktopLayout = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;

            function scrollBlockToStart(withMotion) {
                var header = document.getElementById('site-header');
                var headerOffset = 0;

                if (header) {
                    var headerPosition = window.getComputedStyle(header).position;
                    if (headerPosition === 'sticky' || headerPosition === 'fixed') {
                        headerOffset = Math.ceil(header.getBoundingClientRect().height);
                    }
                }

                var currentScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
                var targetScroll = Math.max(0, Math.round(currentScroll + block.getBoundingClientRect().top - headerOffset));

                if (Math.abs(currentScroll - targetScroll) <= 2) {
                    return Promise.resolve();
                }

                if (!withMotion || !('scrollBehavior' in document.documentElement.style)) {
                    window.scrollTo(0, targetScroll);
                    return Promise.resolve();
                }

                return new Promise(function(resolve) {
                    var startedAt = Date.now();
                    var lastScroll = currentScroll;
                    var stableFrames = 0;
                    var frame;
                    var complete = false;

                    function finish() {
                        if (complete) return;
                        complete = true;
                        if (frame) window.cancelAnimationFrame(frame);
                        resolve();
                    }

                    function checkPosition() {
                        var activeScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
                        var elapsed = Date.now() - startedAt;

                        if (Math.abs(activeScroll - targetScroll) <= 2) {
                            finish();
                            return;
                        }

                        stableFrames = Math.abs(activeScroll - lastScroll) < 1 ? stableFrames + 1 : 0;
                        lastScroll = activeScroll;

                        // Browsers do not consistently expose a scroll-end event.
                        // Once movement settles (or after the safety timeout), begin
                        // the tear from the best scroll position the page can reach.
                        if ((elapsed > 120 && stableFrames >= 4) || elapsed >= 1000) {
                            finish();
                            return;
                        }

                        frame = window.requestAnimationFrame(checkPosition);
                    }

                    window.scrollTo({
                        top: targetScroll,
                        left: 0,
                        behavior: 'smooth'
                    });
                    frame = window.requestAnimationFrame(checkPosition);
                });
            }

            function cancelAnimations() {
                animations.slice().forEach(function(animation) {
                    animation.cancel();
                });
                animations.length = 0;
            }

            function focusSuccess() {
                success.setAttribute('aria-hidden', 'false');

                try {
                    success.focus({ preventScroll: true });
                } catch (error) {
                    success.focus();
                }
            }

            function revealSuccess(withMotion) {
                if (state === 'success') return Promise.resolve();

                state = 'success';
                cancelAnimations();

                var startHeight = Math.ceil(shell.getBoundingClientRect().height);
                shell.style.height = startHeight + 'px';
                shell.style.overflow = 'hidden';

                success.style.opacity = withMotion ? '0' : '';
                success.style.transform = withMotion ? 'translate3d(0, 22px, 0) scale(0.985)' : '';
                success.hidden = false;
                ticket.hidden = true;
                seam.hidden = true;
                formCard.hidden = true;

                block.classList.remove('is-tearing', 'is-cut');
                block.classList.add('is-success');
                block.removeAttribute('aria-busy');

                // Reading layout after the state swap gives us the success card's
                // responsive natural height without ever animating toward "auto".
                var targetHeight = Math.ceil(success.getBoundingClientRect().height);

                if (!withMotion || typeof shell.animate !== 'function') {
                    shell.style.height = '';
                    shell.style.overflow = '';
                    success.style.opacity = '';
                    success.style.transform = '';
                    focusSuccess();
                    return Promise.resolve();
                }

                return Promise.all([
                    playAnimation(shell, [
                        { height: startHeight + 'px' },
                        { height: targetHeight + 'px' }
                    ], {
                        duration: 420,
                        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                        fill: 'both'
                    }, animations),
                    playAnimation(success, [
                        { opacity: 0, transform: 'translate3d(0, 22px, 0) scale(0.985)' },
                        { opacity: 1, transform: 'translate3d(0, -3px, 0) scale(1.006)', offset: 0.78 },
                        { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }
                    ], {
                        duration: 420,
                        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                        fill: 'both'
                    }, animations)
                ]).then(function() {
                    shell.style.height = '';
                    shell.style.overflow = '';
                    success.style.opacity = '';
                    success.style.transform = '';
                    focusSuccess();
                });
            }

            function runTearSequence() {
                if (state !== 'idle') return;

                var shouldReduce = reducedMotion && reducedMotion.matches;
                state = 'positioning';
                block.setAttribute('aria-busy', 'true');
                formCard.setAttribute('inert', '');

                scrollBlockToStart(!shouldReduce).then(function() {
                    if (state !== 'positioning') return;

                    shouldReduce = reducedMotion && reducedMotion.matches;
                    if (shouldReduce || typeof scissors.animate !== 'function') {
                        return revealSuccess(false);
                    }

                    state = 'tearing';
                    block.classList.add('is-tearing');

                    var isDesktop = desktopLayout ? desktopLayout.matches : window.innerWidth >= 992;
                    var lineBox = seamLine.getBoundingClientRect();
                    var distance = Math.max(0, Math.round(isDesktop ? lineBox.height : lineBox.width));
                    var scissorFrames;
                    var progressFrames;

                    if (isDesktop) {
                        scissorFrames = [
                            { opacity: 0, transform: 'translate3d(-50%, -50%, 0) rotate(-4deg)' },
                            { opacity: 1, transform: 'translate3d(-50%, -50%, 0) rotate(3deg)', offset: 0.08 },
                            { opacity: 1, transform: 'translate3d(-50%, calc(-50% + ' + Math.round(distance * 0.34) + 'px), 0) rotate(-3deg)', offset: 0.38 },
                            { opacity: 1, transform: 'translate3d(-50%, calc(-50% + ' + Math.round(distance * 0.68) + 'px), 0) rotate(4deg)', offset: 0.68 },
                            { opacity: 1, transform: 'translate3d(-50%, calc(-50% + ' + distance + 'px), 0) rotate(0deg)', offset: 0.92 },
                            { opacity: 0, transform: 'translate3d(-50%, calc(-50% + ' + distance + 'px), 0) rotate(0deg)' }
                        ];
                        progressFrames = [
                            { opacity: 1, transform: 'scaleY(0)' },
                            { opacity: 1, transform: 'scaleY(1)' }
                        ];
                    } else {
                        scissorFrames = [
                            { opacity: 0, transform: 'translate3d(-50%, -50%, 0) rotate(-4deg)' },
                            { opacity: 1, transform: 'translate3d(-50%, -50%, 0) rotate(3deg)', offset: 0.08 },
                            { opacity: 1, transform: 'translate3d(calc(-50% + ' + Math.round(distance * 0.34) + 'px), -50%, 0) rotate(-3deg)', offset: 0.38 },
                            { opacity: 1, transform: 'translate3d(calc(-50% + ' + Math.round(distance * 0.68) + 'px), -50%, 0) rotate(4deg)', offset: 0.68 },
                            { opacity: 1, transform: 'translate3d(calc(-50% + ' + distance + 'px), -50%, 0) rotate(0deg)', offset: 0.92 },
                            { opacity: 0, transform: 'translate3d(calc(-50% + ' + distance + 'px), -50%, 0) rotate(0deg)' }
                        ];
                        progressFrames = [
                            { opacity: 1, transform: 'scaleX(0)' },
                            { opacity: 1, transform: 'scaleX(1)' }
                        ];
                    }

                    return Promise.all([
                        playAnimation(scissors, scissorFrames, {
                            duration: 720,
                            easing: 'cubic-bezier(0.45, 0, 0.2, 1)',
                            fill: 'both'
                        }, animations),
                        playAnimation(seamProgress, progressFrames, {
                            duration: 720,
                            easing: 'linear',
                            fill: 'both'
                        }, animations)
                    ]).then(function() {
                        if (state !== 'tearing') return;
                        block.classList.add('is-cut');

                        var ticketExit = isDesktop
                            ? 'translate3d(-115%, -4%, 0) rotate(-7deg)'
                            : 'translate3d(0, -110%, 0) rotate(-5deg)';

                        return Promise.all([
                            playAnimation(ticket, [
                                { opacity: 1, transform: 'translate3d(0, 0, 0) rotate(0deg)' },
                                { opacity: 1, transform: isDesktop ? 'translate3d(-5%, -1%, 0) rotate(-1deg)' : 'translate3d(0, -4%, 0) rotate(-1deg)', offset: 0.18 },
                                { opacity: 0, transform: ticketExit }
                            ], {
                                duration: 520,
                                easing: 'cubic-bezier(0.55, 0, 1, 0.45)',
                                fill: 'both'
                            }, animations),
                            playAnimation(formContent, [
                                { opacity: 1, transform: 'translate3d(0, 0, 0)' },
                                { opacity: 0, transform: 'translate3d(0, -8px, 0)' }
                            ], {
                                duration: 260,
                                delay: 140,
                                easing: 'ease-in',
                                fill: 'both'
                            }, animations)
                        ]);
                    }).then(function() {
                        if (state === 'tearing') return revealSuccess(true);
                    });
                }).catch(function() {
                    revealSuccess(false);
                });
            }

            function finishIfLayoutChanges() {
                if (state === 'tearing') revealSuccess(false);
            }

            cf7Wrapper.addEventListener('wpcf7mailsent', runTearSequence);

            [reducedMotion, desktopLayout].forEach(function(mediaQuery) {
                if (!mediaQuery) return;
                if (typeof mediaQuery.addEventListener === 'function') {
                    mediaQuery.addEventListener('change', finishIfLayoutChanges);
                } else if (typeof mediaQuery.addListener === 'function') {
                    mediaQuery.addListener(finishIfLayoutChanges);
                }
            });
        }

        function initialiseBlocks() {
            document.querySelectorAll('.ticket_booking').forEach(function(block) {
                initialiseBackgroundVideo(block);
                initialiseSuccessAnimation(block);
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initialiseBlocks);
        } else {
            initialiseBlocks();
        }
    })();

})();
